(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("BootstrapVue"), require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["BootstrapVue", ], factory);
	else if(typeof exports === 'object')
		exports["viewer"] = factory(require("BootstrapVue"), require("vue"));
	else
		root["viewer"] = factory(root["BootstrapVue"], root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__0089__, __WEBPACK_EXTERNAL_MODULE__8bbf__) {
return 